import { Public, ProtectedRoute, PrivilegedRoute } from '@middlewares';

import Eventos from '@pages/Events/Eventos';
import PreguntasPost from '@pages/Events/PreguntasPost';
import Invitados from '@pages/Events/Invitados';
import InvitadosEvent from '@pages/Events/InvitadosEvent';
import Staff from '@pages/Events/Staff';
import StaffEvent from '@pages/Events/StaffEvent';
import EventosPaseLista from '@pages/Events/EventosPaseLista';
import EventosPaseListaInfo from '@pages/Events/EventosPaseListaInfo';
import PreRegistro from '@pages/Events/PreRegistro';
import Dashboard from '@pages/Events/Dashboard';

import { ID_EVENTOS } from '@data/constants/Eventos';

const EventsRoutes = [
  {
    path: '/eventos',
    element: <PrivilegedRoute title="Eventos" page={<Eventos idTipoEvento={ID_EVENTOS} id="eventos" />} />,
  },
  {
    path: '/eventos/preguntas',
    element: (
      <ProtectedRoute title="Preguntas" page={<PreguntasPost idTipoEvento={ID_EVENTOS} id="eventos" />} />
    ),
  },
  {
    path: '/eventos/invitados',
    element: (
      <PrivilegedRoute title="Invitados" page={<Invitados idTipoEvento={ID_EVENTOS} id="eventos" />} />
    ),
  },
  {
    path: '/eventos/invitados/:id',
    element: <ProtectedRoute title="Invitados" page={<InvitadosEvent />} />,
  },
  {
    path: '/eventos/staff',
    element: <PrivilegedRoute title="Staff" page={<Staff idTipoEvento={ID_EVENTOS} id="eventos" />} />,
  },
  {
    path: '/eventos/staff/:id',
    element: <ProtectedRoute title="Staff" page={<StaffEvent />} />,
  },
  {
    path: '/eventos/pase-lista',
    element: <PrivilegedRoute title="Pase de lista" page={<EventosPaseLista idTipoEvento={ID_EVENTOS} />} />,
  },
  {
    path: '/eventos/pase-lista/:id',
    element: <ProtectedRoute title="Pase de lista" page={<EventosPaseListaInfo />} />,
  },
  {
    path: '/eventos/dashboard/:id',
    element: <ProtectedRoute title="Dashboard" page={<Dashboard />} />,
  },
  {
    path: '/eventos/preregistro/:id',
    element: <Public title="Preregistro" page={<PreRegistro idTipoEvento={ID_EVENTOS} />} />,
  },
];

export default EventsRoutes;
